import(/* webpackMode: "eager" */ "D:\\Source\\Personal\\xoso\\xoso-client\\src\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Web3Provider"] */ "D:\\Source\\Personal\\xoso\\xoso-client\\src\\providers\\Web3Provider.tsx");
